module.exports = __webpack_public_path__ + "img/bulldozing-icon4.54e6c0b5.png";